<template>
  <section
    class="spheres-carousel-module-component"
    :class="device === 'mobile' ? 'mobile' : ''">
    <div class="inner-container middle-line-animation">
      <div
        class="vertical-line-top"
        :style="`background-color: ${data.settings.line_color};`"></div>
      <div
        class="orb"
        :style="`background-color: ${data.settings.orb_color};`"></div>
    </div>
    <div class="inner-container second-row">
      <div class="inner-fence">
        <div
          class="title-area"
          v-html="data.top_section.title" />
        <div
          class="content-area"
          v-html="data.top_section.content" />
      </div>
    </div>
    <div class="inner-container circles">
      <div class="circle-left">
        <svg
          class="side"
          data-name="left-sphere"
          viewBox="0 0 397.59 289.45">
          <defs>
            <clipPath id="clippath">
              <path
                class="clip-path"
                d="M285.6,144.74c0-38.89-15.4-74.19-40.42-100.13-21.89-18.81-44.56-34.16-69.67-39.11C94.65-10.44,4.3,53.37,4.3,145.2s90.73,152.99,171.21,139.32c2.33-.4,4.64-.9,6.93-1.47,11.85-3.52,23.07-8.51,33.43-14.77,4.2-2.6,8.35-5.43,12.45-8.45,34.79-26.34,57.28-68.08,57.28-115.09Z" />
            </clipPath>
          </defs>
          <path
            class="path"
            d="M175.51,5.07c80.86,15.94,136.42,139.7,222.08,139.7-85.66,0-141.6,125.65-222.08,139.32C95.03,297.76,4.3,236.6,4.3,144.77,4.3,52.94,94.65-10.87,175.51,5.07Z" />
          <g class="source-img">
            <image
              width="289"
              height="289"
              transform="scale(1.01)"
              :xlink:href="data.spheres.left_sphere.background.url" />
          </g>
        </svg>
        <h3
          class="sphere-title"
          v-html="data.spheres.left_sphere.title" />
      </div>

      <div
        v-show="device !== 'mobile'"
        class="circle-carousel">
        <svg
          class="center z-1"
          data-name="circle_carousel"
          viewBox="0 0 489 526">
          <defs>
            <linearGradient
              id="linear-gradient"
              x1="61.36"
              y1="245"
              x2="425.58"
              y2="245"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0"
                stop-color="#99b4ff" />
              <stop
                offset="1"
                stop-color="#ffad39" />
            </linearGradient>
            <linearGradient
              id="linear-gradient-2"
              x1="56"
              y1="110"
              x2="56"
              y2="-379"
              gradientTransform="translate(111 302) rotate(-90) scale(1 -1)"
              xlink:href="#linear-gradient" />
          </defs>
          <path
            d="M.5,247.5v-3C.5,109.74,109.74.5,244.5.5h0c134.76,0,244,109.24,244,244v3c0,134.76-109.24,244-244,244h0C109.74,491.5.5,382.26.5,247.5Z"
            style="fill: white; stroke: url(#linear-gradient-2)" />
          <g
            id="animated-group"
            ref="animatedGroup"
            class="animated-section">
            <circle
              cx="243.47"
              cy="245"
              r="181.6"
              style="
                fill: none;
                stroke: url(#linear-gradient);
                stroke-dasharray: 0 0 4 6.01;
              " />
            <circle
              ref="circle"
              cx="243.47"
              cy="245"
              r="171.68"
              style="
                fill: #382c75;
                isolation: isolate;
                opacity: 0.2;
                stroke-width: 0px;
              " />
            <circle
              ref="bubble4"
              cx="132.69"
              cy="102.57"
              r="18.46"
              style="cursor: pointer; fill: #6fcfd7; stroke-width: 0px"
              @click="current = 3" />
            <circle
              ref="bubble3"
              cx="357.42"
              cy="102.57"
              r="18.46"
              style="cursor: pointer; fill: #ffad39; stroke-width: 0px"
              @click="current = 2" />
            <circle
              ref="bubble2"
              cx="418.62"
              cy="294.59"
              r="18.46"
              style="cursor: pointer; fill: #ff6d00; stroke-width: 0px"
              @click="current = 1" />
            <circle
              ref="bubble5"
              cx="69.38"
              cy="294.59"
              r="18.46"
              style="cursor: pointer; fill: #99b4ff; stroke-width: 0px"
              @click="current = 4" />
            <circle
              ref="bubble1"
              cx="243.47"
              cy="427.54"
              r="18.46"
              style="cursor: pointer; fill: #382c75; stroke-width: 0px"
              @click="current = 0" />
          </g>
          <line
            ref="line"
            x1="243.5"
            y1="422"
            x2="243.5"
            y2="517"
            style="fill: none; stroke: #382c75" />
          <circle
            ref="dot"
            cx="243.5"
            cy="520.5"
            r="5.5"
            style="fill: #382c75; stroke-width: 0px" />
        </svg>
        <div
          ref="circleText"
          class="circle-content">
          <div
            v-for="(circContent, i) of data.spheres.carousel"
            :key="`circ-content-${i}`"
            class="single-circle-content">
            <transition
              name="fade"
              mode="out-in">
              <div
                v-if="i === activeBubble"
                class="content">
                <p class="sphere-sub-title">{{ circContent.subtitle }}</p>
                <h3
                  class="sphere-title"
                  v-html="circContent.title" />
              </div>
            </transition>
          </div>
        </div>
      </div>
      <div
        v-show="device === 'mobile'"
        class="circle-carousel-mobile z-1">
        <svg
          class="circle-mobile"
          data-name="circle-mobile"
          viewBox="0 0 406 406">
          <defs>
            <linearGradient
              id="linear-gradient-mobile"
              x1="112"
              y1="295"
              x2="-294"
              y2="295"
              gradientTransform="translate(498 112) rotate(-90) scale(1 -1)"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0"
                stop-color="#99b4ff" />
              <stop
                offset="1"
                stop-color="#ffad39" />
            </linearGradient>
          </defs>
          <circle
            cx="203"
            cy="203"
            r="202"
            style="
              fill: #fff;
              stroke: url(#linear-gradient-mobile);
              stroke-width: 2px;
            " />
          <circle
            cx="203.06"
            cy="203"
            r="170"
            style="
              fill: none;
              stroke: url(#linear-gradient-mobile);
              stroke-dasharray: 0 0 0 0 0 0 4 6.01;
            " />
          <g @click="mobileCurrent = 2">
            <ellipse
              v-if="mobileCurrent !== 2"
              cx="366.9"
              cy="248.84"
              rx="18.04"
              ry="18.13"
              style="fill: #ffad39; stroke-width: 0px" />
            <path
              d="M369.85,225.67c-12.73,0-23.06,10.37-23.06,23.17s10.32,23.17,23.06,23.17,23.06-10.37,23.06-23.17-10.32-23.17-23.06-23.17ZM369.85,255.89c-3.88,0-7.02-3.16-7.02-7.05s3.14-7.05,7.02-7.05,7.02,3.16,7.02,7.05-3.14,7.05-7.02,7.05Z"
              style="fill: #ffad39; stroke-width: 0px" />
          </g>
          <g @click="mobileCurrent = 3">
            <ellipse
              v-if="mobileCurrent !== 3"
              cx="309.76"
              cy="69.51"
              rx="18.04"
              ry="18.13"
              style="fill: #6fcfd7; stroke-width: 0px" />
            <path
              d="M309.76,46.33c-12.73,0-23.06,10.37-23.06,23.17s10.32,23.17,23.06,23.17,23.06-10.37,23.06-23.17-10.32-23.17-23.06-23.17ZM309.76,76.56c-3.88,0-7.02-3.16-7.02-7.05s3.14-7.05,7.02-7.05,7.02,3.16,7.02,7.05-3.14,7.05-7.02,7.05Z"
              style="fill: #6fcfd7; stroke-width: 0px" />
          </g>
          <g @click="mobileCurrent = 0">
            <ellipse
              v-if="mobileCurrent !== 0"
              cx="38.1"
              cy="248.84"
              rx="18.04"
              ry="18.13"
              style="fill: #382c75; stroke-width: 0px" />
            <path
              d="M38.1,225.67c-12.73,0-23.06,10.37-23.06,23.17s10.32,23.17,23.06,23.17,23.06-10.37,23.06-23.17-10.32-23.17-23.06-23.17ZM38.1,255.89c-3.88,0-7.02-3.16-7.02-7.05s3.14-7.05,7.02-7.05,7.02,3.16,7.02,7.05-3.14,7.05-7.02,7.05Z"
              style="fill: #382c75; stroke-width: 0px" />
          </g>
          <g @click="mobileCurrent = 4">
            <ellipse
              v-if="mobileCurrent !== 4"
              cx="99.24"
              cy="69.51"
              rx="18.04"
              ry="18.13"
              style="fill: #99b4ff; stroke-width: 0px" />
            <path
              d="M99.24,46.33c-12.73,0-23.06,10.37-23.06,23.17s10.32,23.17,23.06,23.17,23.06-10.37,23.06-23.17-10.32-23.17-23.06-23.17ZM99.24,76.56c-3.88,0-7.02-3.16-7.02-7.05s3.14-7.05,7.02-7.05,7.02,3.16,7.02,7.05-3.14,7.05-7.02,7.05Z"
              style="fill: #99b4ff; stroke-width: 0px" />
          </g>
          <g @click="mobileCurrent = 1">
            <ellipse
              v-if="mobileCurrent !== 1"
              cx="203.06"
              cy="374.76"
              rx="18.04"
              ry="18.13"
              style="fill: #ff6d00; stroke-width: 0px" />
            <path
              d="M203.06,351.59c-12.73,0-23.06,10.37-23.06,23.17s10.32,23.17,23.06,23.17,23.06-10.37,23.06-23.17-10.32-23.17-23.06-23.17ZM203.06,381.81c-3.88,0-7.02-3.16-7.02-7.05s3.14-7.05,7.02-7.05,7.02,3.16,7.02,7.05-3.14,7.05-7.02,7.05Z"
              style="fill: #ff6d00; stroke-width: 0px" />
          </g>
          <path
            d="M345.19,203.12c.1,78.7-63.61,142.59-142.31,142.69-78.7.1-142.58-63.61-142.69-142.31-.1-78.7,63.61-142.58,142.31-142.69,78.7-.1,142.58,63.61,142.69,142.31Z"
            :style="`fill: ${mobileActiveColor}; isolation: isolate; opacity: .2; stroke-width: 0px;`" />
        </svg>
        <transition>
          <div
            v-if="mobileCurrent === 5"
            class="default">
            <h2 class="sphere-sub-title">
              Rapid, Multidisciplinary Preclinical Development
            </h2>
            <p class="sphere-sub-title">[Tap on any dot]</p>
          </div>
        </transition>
        <template
          v-for="(mTitleOnly, mobIndxTitle) of data.spheres.carousel"
          :key="`mob-title-${mobIndxTitle}`">
          <transition name="fade">
            <div
              v-if="mobileCurrent === mobIndxTitle"
              class="titles">
              <h2 v-html="mTitleOnly.title" />
              <div
                class="button"
                :style="`background-color:${mobileActiveColor};`"
                @click="mobileDetails = true">
                Read More
              </div>
            </div>
          </transition>
        </template>
        <transition name="fade">
          <div
            v-if="mobileDetails"
            class="content-container">
            <div
              class="bg-circle"
              :style="`background-color: ${mobileActiveColor};`"></div>
            <div class="content">
              <template
                v-for="(mTitle, mobIndx) of data.spheres.carousel"
                :key="`mob-title-${mobIndx}`">
                <div
                  v-if="mobIndx === mobileCurrent"
                  class="text-container">
                  <h2
                    class="sphere-sub-title"
                    v-html="mTitle.title" />
                  <p class="sphere-sub-title">{{ mTitle.content }}</p>
                  <div
                    class="button"
                    @click="mobileDetails = false">
                    Close
                  </div>
                </div>
              </template>
            </div>
          </div>
        </transition>
      </div>
      <div class="circle-right">
        <svg
          class="side"
          data-name="right-sphere"
          viewBox="0 0 445.05 290.09">
          <defs>
            <clipPath id="clippath-1">
              <circle
                class="clip-path"
                cx="300"
                cy="145.04"
                r="145.04" />
            </clipPath>
          </defs>
          <g class="source-img bottom">
            <image
              width="289"
              height="289"
              transform="translate(155.5 .54)"
              :xlink:href="data.spheres.right_sphere.background.url" />
          </g>
          <path
            class="path"
            transform="translate(-0 -16)"
            d="M.38,293.99c49-58.67,94.86-138.94,154.64-138.94C95.38,155.05,49.76,76.34.89,17.54" />
        </svg>
        <h3 class="sphere-title">{{ data.spheres.right_sphere.title }}</h3>
      </div>
    </div>
    <div
      v-if="device !== 'mobile'"
      class="inner-container info-carousel">
      <div class="info-carousel">
        <div
          class="left-arrow transition-opacity easing-in-out duration-500"
          :class="`${transitioning ? 'opacity-0' : 'cursor-pointer'}`"
          @click="backward()">
          <ArrowCircleButton class="rotate-180" />
        </div>
        <div class="info-carousel-content">
          <div class="info-carousel-content-inner">
            <template
              v-for="(content, indx) of data.spheres.carousel"
              :key="`slide-${indx}`">
              <transition
                name="fade"
                mode="out-in">
                <div
                  v-if="activeSlide === indx && !transitioning"
                  class="content">
                  {{ content.content }}
                </div>
              </transition>
            </template>
          </div>
        </div>
        <div
          :class="`${transitioning ? 'opacity-0' : 'cursor-pointer'}`"
          class="right-arrow transition-opacity easing-in-out duration-500"
          @click="forward()">
          <ArrowCircleButton />
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
/* #META
{
  "NAME": "SpheresCarouselComponent",
  "CLASSNAME": "spheres-carousel-module-component",
  "URL": "http://lifemine.local/templates/"
}
#ENDMETA */
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
import { watch, ref, onMounted, onBeforeUnmount } from 'vue'
import useUtils from '@/composables/useUtils'
import ArrowCircleButton from '../utility/ArrowCircleButton.vue'

const { device } = useUtils()
gsap.registerPlugin(ScrollTrigger)
defineProps(['data'])
// console.log(props.data)

const animatedGroup = ref(null)
const bubble1 = ref(null)
const bubble2 = ref(null)
const bubble3 = ref(null)
const bubble4 = ref(null)
const bubble5 = ref(null)
const circle = ref(null)
const circleText = ref(null)
const line = ref(null)
const dot = ref(null)
const current = ref(0)
const direction = ref(1)
const activeBubble = ref(0)
const activeSlide = ref(0)
const transitioning = ref(false)
const mobileCurrent = ref(5)
const mobileDetails = ref(false)
const mobileActiveColor = ref('#F3F0ED')

// MobileStuff
watch(mobileCurrent, (val) => {
  if (val === 0) {
    mobileActiveColor.value = '#382c75'
  } else if (val === 1) {
    mobileActiveColor.value = '#ff6d00'
  } else if (val === 2) {
    mobileActiveColor.value = '#ffad39'
  } else if (val === 3) {
    mobileActiveColor.value = '#6fcfd7'
  } else if (val === 4) {
    mobileActiveColor.value = '#99b4ff'
  }
})

watch(current, (val, prev) => {
  let currentBubble = null

  switch (prev) {
    case 0:
      currentBubble = bubble1.value
      break
    case 1:
      currentBubble = bubble2.value
      break
    case 2:
      currentBubble = bubble3.value
      break
    case 3:
      currentBubble = bubble4.value
      break
    case 4:
      currentBubble = bubble5.value
      break
  }

  if (val === 0) {
    transitioning.value = true
    sequenceForward(currentBubble, bubble1.value, '#382c75', 0)
    activeBubble.value = 0
    setTimeout(() => {
      activeSlide.value = 0
      transitioning.value = false
    }, 2600)
  } else if (val === 1) {
    transitioning.value = true
    sequenceForward(currentBubble, bubble2.value, '#ff6d00', 73)
    activeBubble.value = 1
    setTimeout(() => {
      activeSlide.value = 1
      transitioning.value = false
    }, 2600)
  } else if (val === 2) {
    transitioning.value = true
    sequenceForward(currentBubble, bubble3.value, '#ffad39', 142)
    activeBubble.value = 2
    setTimeout(() => {
      activeSlide.value = 2
      transitioning.value = false
    }, 2600)
  } else if (val === 3) {
    transitioning.value = true
    sequenceForward(currentBubble, bubble4.value, '#6fcfd7', 219)
    activeBubble.value = 3
    setTimeout(() => {
      activeSlide.value = 3
      transitioning.value = false
    }, 2600)
  } else if (val === 4) {
    transitioning.value = true
    sequenceForward(currentBubble, bubble5.value, '#99b4ff', 287)
    activeBubble.value = 4
    setTimeout(() => {
      activeSlide.value = 4
      transitioning.value = false
    }, 2600)
  }
})

//

const forward = () => {
  if (transitioning.value) return
  transitioning.value = true
  current.value++
  direction.value = 1
  if (current.value > 4) {
    current.value = 0
  }
  setTimeout(() => {
    activeBubble.value = current.value
  }, 1400)
  setTimeout(() => {
    activeSlide.value = current.value
    transitioning.value = false
  }, 2600)
}

const backward = () => {
  if (transitioning.value) return
  transitioning.value = true
  current.value--
  direction.value = -1
  if (current.value < 0) {
    current.value = 4
  }
  setTimeout(() => {
    activeBubble.value = current.value
  }, 1400)
  setTimeout(() => {
    activeSlide.value = current.value
    transitioning.value = false
  }, 2600)
}

const initialAnimation = () => {
  transitioning.value = true
  gsap.fromTo(
    animatedGroup.value,
    {
      opacity: 0,
    },
    {
      scrollTrigger: {
        trigger: animatedGroup.value,
        id: 'initial-animation-circle',
        start: 'top center',
        end: 'bottom center',
        markers: false,
      },
      opacity: 1,
      duration: 1,
    }
  )
  gsap.fromTo(
    circleText.value,
    {
      opacity: 0,
    },
    {
      scrollTrigger: {
        trigger: animatedGroup.value,
        id: 'initial-animation-text',
        start: 'top center',
        end: 'bottom center',
        markers: false,
      },
      opacity: 1,
      duration: 1,
      delay: 1.3,
    }
  )
  gsap.fromTo(
    [bubble2.value, bubble3.value, bubble4.value, bubble5.value],
    {
      transformOrigin: '50% 50%',
      scale: 0,
      opacity: 0,
    },
    {
      scrollTrigger: {
        trigger: animatedGroup.value,
        id: 'initial-animation-bubbles',
        start: 'top center',
        end: 'bottom center',
        markers: false,
      },
      scale: 1,
      stagger: 0.3,
      opacity: 1,
      duration: 1,
      ease: 'back.out(2)',
      delay: 2,
    }
  )

  gsap.fromTo(
    bubble1.value,
    {
      transformOrigin: '50% 50%',
      scale: 0,
      filter: 'drop-shadow(0px 0px 0px #382c75)',
    },
    {
      scrollTrigger: {
        trigger: animatedGroup.value,
        id: 'initial-animation-bubble1',
        start: 'top center',
        end: 'bottom center',
        markers: false,
      },
      scale: 1.3,
      duration: 0.8,
      ease: 'back.out(2)',
      filter: 'drop-shadow(0px 2px 12px #382c75)',
      delay: 3.3,
    }
  )

  gsap.fromTo(
    line.value,
    {
      scaleY: 0,
      transformOrigin: 'top',
    },
    {
      scrollTrigger: {
        trigger: animatedGroup.value,
        id: 'initial-animation-line',
        start: 'top center',
        end: 'bottom center',
        markers: false,
      },
      scaleY: 1,
      ease: 'power2.out',
      duration: 0.5,
      delay: 3.5,
    }
  )

  gsap.fromTo(
    dot.value,
    {
      transformOrigin: '50% 50%',
      scale: 0,
    },
    {
      scrollTrigger: {
        trigger: animatedGroup.value,
        id: 'initial-animation-dot',
        start: 'top center',
        end: 'bottom center',
        markers: false,
      },
      scale: 1,
      duration: 0.5,
      ease: 'back.out(2)',
      delay: 4,
      onComplete: () => {
        transitioning.value = false
      },
    }
  )
}

const sequenceForward = (prevBubble, currentBubble, color, rotation) => {
  gsap.to(dot.value, {
    scale: 0,
    duration: 0.3,
    ease: 'back.out(2)',
    onComplete: () => {
      gsap.set(dot.value, {
        fill: color,
      })
    },
  })
  gsap.to(line.value, {
    scaleY: 0,
    duration: 0.3,
    ease: 'back.out(2)',
    delay: 0.3,
    onComplete: () => {
      gsap.set(line.value, {
        stroke: color,
      })
    },
  })
  gsap.to(prevBubble, {
    scale: 1,
    filter: `drop-shadow(0px 0px 0px ${color})`,
    duration: 0.3,
    ease: 'back.out(2)',
    delay: 0.6,
  })
  gsap.to(animatedGroup.value, {
    rotation: rotation,
    transformOrigin: '50.1% 46.7%',
    duration: 1,
    ease: 'back.out(1)',
    delay: 0.9,
  })
  gsap.to(circle.value, {
    fill: color,
    duration: 1,
    delay: 0.9,
  })
  gsap.to(currentBubble, {
    scale: 1.3,
    filter: `drop-shadow(0px 2px 12px ${color})`,
    duration: 0.3,
    ease: 'back.out(2)',
    delay: 1.9,
  })
  gsap.to(line.value, {
    scaleY: 1,
    duration: 0.3,
    ease: 'back.out(2)',
    delay: 2.2,
  })
  gsap.to(dot.value, {
    scale: 1,
    duration: 0.3,
    ease: 'back.out(2)',
    delay: 2.5,
  })
}

onMounted(() => {
  initialAnimation()
})

onBeforeUnmount(() => {
  ScrollTrigger.getById('initial-animation-circle')?.kill()
  ScrollTrigger.getById('initial-animation-text')?.kill()
  ScrollTrigger.getById('initial-animation-bubbles')?.kill()
  ScrollTrigger.getById('initial-animation-bubble1')?.kill()
  ScrollTrigger.getById('initial-animation-line')?.kill()
  ScrollTrigger.getById('initial-animation-dot')?.kill()
})
</script>

<style lang="scss">
.spheres-carousel-module-component {
  &.mobile {
    @apply pb-24;
  }
  .inner-container.middle-line-animation {
    @apply relative pb-10 mb-0 lg:mb-20;
    .vertical-line-top {
      @apply absolute h-10 lg:h-28 w-[1px] left-[calc(100%-30px)] md:left-[calc(100%-60px)] lg:left-1/2 top-0 z-10 origin-top;
    }
    .orb {
      @apply absolute w-4 h-4 rounded-full left-[calc(100%-38px)] md:left-[calc(100%-68px)] lg:left-[calc(50%-8px)] top-10 lg:top-28;
    }
  }
  .inner-container.second-row {
    @apply pt-2 lg:pt-0;
    .inner-fence {
      @apply flex flex-col px-6 -mt-6;
      .title-area {
        @apply heading-2 mb-8 w-6/12 xl:w-full pr-0 lg:pr-10;
      }
      .content-area {
        @apply medium columns-1 lg:columns-2 gap-[60px];
        p {
          @apply mb-6;
        }
      }
    }
  }
  .inner-container.circles {
    @apply flex flex-col md:flex-row items-center justify-center pt-16 pb-8 px-4 lg:px-[75px];
    .circle-left {
      @apply flex w-full lg:w-[28.5%] relative;
      .sphere-title {
        @apply absolute text-white text-[25px] md:text-[18px] xl:text-[25px] leading-tight max-w-[53%] md:max-w-[55%] text-center top-[7%] md:top-[30%] lg:top-[25%] xl:top-[30%] left-[23%] md:left-[8%] lg:left-[8%];
      }
      .side {
        @apply object-contain object-right w-full rotate-90 md:rotate-0;
        .path {
          stroke: #99b4ff;
          fill: none;
        }
        .clip-path {
          fill: none;
          stroke-width: 0px;
        }
        .source-img {
          clip-path: url(#clippath);
        }
      }
    }
    .circle-carousel {
      @apply flex w-full lg:w-[40%] relative;
      .center {
        @apply object-contain object-center w-full;
        .animated-section {
          transform-origin: 50.1% 46.7%;
        }
      }
      .circle-content {
        @apply absolute w-full max-w-[60%] top-[20%] md:top-[35%] xl:top-[35%] left-[20%] text-center z-1;
        @media (min-width: 768px) and (max-width: 865px) {
          top: 26%;
        }
        @media (min-width: 1110px) and (max-width: 1279px) {
          top: 32%;
        }
        .content {
          @apply absolute;
          h3 {
            @apply medium xl:heading-4 min-h-[80px] lg:min-h-[105px] flex items-center justify-center leading-[20px] xl:leading-[38px];
            @apply w-full max-w-full mx-auto;
            @media (min-width: 768px) and (max-width: 1279px) {
              word-break: break-word;
            }
          }
          p {
            @apply text-[12px] leading-[12px] xl:text-[18px] xl:leading-[18px] small max-w-[80%] mx-auto;
          }
        }
      }
    }
    .circle-carousel-mobile {
      @apply flex w-full lg:w-[40%] pt-10 pb-4 relative;
      .circle-mobile {
        @apply object-contain object-center w-full h-full;
      }
      .default {
        @apply absolute top-[32%] left-[20%] right-0 text-center w-[60%];
        h2 {
          @apply text-[28px] leading-[32px] mb-6 mx-auto;
        }
        p {
          @apply caption opacity-60;
        }
      }
      .titles {
        @apply absolute top-[40%] left-[20%] right-0 text-center w-[60%];
        h2 {
          @apply text-[30px] leading-[34px] mb-6 mx-auto break-words;
        }
        .button {
          @apply text-white py-3 px-8 w-fit mx-auto mt-6 cursor-pointer;
        }
      }
      .bg-circle {
        @apply absolute w-full aspect-square top-10 left-0 right-0 bottom-0 z-2 rounded-full;
      }
      .content {
        @apply absolute w-full top-[25%] left-0 right-0 text-center max-w-[83%] mx-auto;
        .text-container {
          @apply z-3 relative;
          h2 {
            @apply text-[28px] leading-[32px] mb-6 max-w-[90%] mx-auto text-white;
          }
          p {
            @apply text-[22px] leading-[28px] text-white;
          }
          .button {
            @apply bg-lm_white text-black py-3 px-8 w-fit mx-auto mt-6 cursor-pointer;
          }
        }
      }
    }
    .circle-right {
      @apply flex w-full lg:w-[31.5%] -left-[3.8%] lg:-left-[2.6%] top-[7px] md:-top-[0px] relative;
      .sphere-title {
        @apply absolute text-white text-[25px] md:text-[18px] xl:text-[25px] leading-tight
        max-w-[55%] text-center top-[65%] md:top-[35%] lg:top-[30%] xl:top-[37%] left-[23%] md:left-[40%];
      }
      .side {
        @apply object-contain object-left w-full translate-x-[8px] md:translate-x-[-2px] translate-y-[-2px] md:translate-y-[-10px] rotate-90 md:rotate-0;
        .source-img {
          clip-path: url(#clippath1);
        }

        .clip-path {
          stroke-width: 0px;
        }

        .clip-path,
        .path {
          fill: none;
        }

        .path {
          stroke: #ffad39;
        }
      }
    }
  }
  .inner-container.info-carousel {
    @apply flex max-w-[870px] px-10 py-0 lg:px-0 pb-16;
    .info-carousel {
      @apply flex gap-x-10 w-full;
      .info-carousel-content {
        @apply max-w-[660px] w-full flex items-center;
        .info-carousel-content-inner {
          @apply flex items-center justify-center w-full relative;
          .content {
            @apply absolute large text-center;
          }
        }
      }
      .left-arrow,
      .right-arrow {
        @apply flex items-center justify-center;
        img {
          @apply w-full h-full object-contain;
        }
      }
    }
  }
}
</style>
